<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      save-button-text="Send"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveItemHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
    >
      <v-container>
        <v-row class="mt-5">
          <v-col cols="12">
            <v-text-field
                v-model="currentItem.email"
                :rules="requiredFieldRule"
                label="Email"
                prepend-icon="mdi-email"
                required
                placeholder="Enter your email"
                dense
                outlined
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </base-popup>
</template>
<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";

export default {
  name: 'ForgotPassword',
  components: {BasePopup},
  mixins: [PopupMixin],
  computed: {
    formTitle() {
      return this.isEditMode
          ? 'Edit Method'
          : 'Forgot Password'
    }
  }
}
</script>
